export class BrokerageFirm {
    id: string | undefined;
    name: string | undefined;
    url: string | undefined;
    date: Date | undefined;
    lang: string | undefined;
    country: string | undefined;
    createDate: Date | undefined;
    endDate: Date | undefined;
    startDate: Date | undefined;
    status: boolean | undefined;

}
